import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {BlockUI} from "primereact/blockui";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import {Divider} from "primereact/divider";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

const formatDataRO = (str) => {
	if (!str) return '';
	const luni = ['Ian','Feb','Mar','Apr','Mai','Iun','Iul','Aug','Sep','Oct','Nov','Dec'];
	const d = new Date(str.replace(' ', 'T'));
	if (isNaN(d)) return str;
	return String(d.getDate()).padStart(2,'0') + '-' + luni[d.getMonth()] + '-' + d.getFullYear();
};

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	fiscal_code: "",
	address: "",
	email: "",
	phone: "",
	general_manager: "",
	economic_manager: "",
	aquisition_manager: "",
};

let defaultAnafConfig = {
	has_token: 0,
	token_expires_at: "",
};

const UnitData = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.centerId?props.centerId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [blockScreen, setBlockScreen] = useState(false);
	const [anafConfig, setAnafConfig] = useState(defaultAnafConfig);
	const [anafCode, setAnafCode] = useState("");
	const [authorizeUrl, setAuthorizeUrl] = useState("");
	const [openAnafDialog, setOpenAnafDialog] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		setInputValues({...inputValues,[name]:value});
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			if(inputValues.fiscal_code==="") {
				setMessageText("Eroare: Completati campul cod fiscal!");				
				document.getElementById("fiscal_code").classList.add("required_input_error");
				return false;
			}
			if(inputValues.phone==="") {
				setMessageText("Eroare: Completati campul telefon!");				
				document.getElementById("phone").classList.add("required_input_error");
				return false;
			}
			if(inputValues.email==="") {
				setMessageText("Eroare: Completati campul email!");				
				document.getElementById("email").classList.add("required_input_error");
				return false;
			}
			if(inputValues.address==="") {
				setMessageText("Eroare: Completati campul adresa!");				
				document.getElementById("address").classList.add("required_input_error");
				return false;
			}
			if(inputValues.general_manager==="") {
				setMessageText("Eroare: Completati campul director general!");				
				document.getElementById("general_manager").classList.add("required_input_error");
				return false;
			}
			if(inputValues.economic_manager==="") {
				setMessageText("Eroare: Completati campul director economic!");				
				document.getElementById("economic_manager").classList.add("required_input_error");
				return false;
			}
			if(inputValues.aquisition_manager==="") {
				setMessageText("Eroare: Completati campul ACPSSA!");				
				document.getElementById("aquisition_manager").classList.add("required_input_error");
				return false;
			}
			let url="saveUnitData";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")) {
			setInputValues((result.unitData?result.unitData:defaultInputValues));
			if(!dataOk) {
				setDataOk(true);
			}
			oper="";
			if(result.unitData) {
				loadAnafConfig();
			}
		}

		if(oper==="getAnafAuthorizeUrl") {
			if(result.url) {
				// Redirecteaza tab-ul curent spre ANAF (nu tab nou)
				// La intoarcere, MainPage detecteaza automat codul din URL
				window.location.href = result.url;
			}
			oper="";
		}
		if(oper==="anafExchangeCode") {
			setOpenAnafDialog(false);
			setAnafCode("");
			loadAnafConfig();
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			// Mesaj dupa callback ANAF
			const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
			if(params.get('anaf') === 'ok') {
				setMessageText("Token ANAF obtinut cu succes!");
				window.history.replaceState(null, '', window.location.pathname + '#/unitData');
			}else if(params.get('anaf') === 'error') {
				setMessageText("Eroare la obtinerea tokenului ANAF. Incercati din nou.");
				window.history.replaceState(null, '', window.location.pathname + '#/unitData');
			}
			oper="get";
			let url="getUnitData";
			url+="?session_id="+props.session.sessId;
			fetch_url_post(url,{},success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const loadAnafConfig = () => {
		let url="getEFacturaOauth?session_id="+props.session.sessId;
		fetch_url_post(url,{},(result) => {
			if(result && result.data) {
				setAnafConfig({has_token: result.data.has_token || 0, token_expires_at: result.data.token_expires_at || ""});
			}
		},() => {});
	}

	const handleGetAuthorizeUrl = () => {
		oper="getAnafAuthorizeUrl";
		let url="getAnafAuthorizeUrl?session_id="+props.session.sessId;
		fetch_url_post(url,{},success_handler,fail_handler);
	}

	const handleExchangeCode = () => {
		if(!anafCode.trim()) {
			setMessageText("Introduceti codul de autorizare!");
			return;
		}
		oper="anafExchangeCode";
		let url="anafExchangeCode?session_id="+props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url,{code: anafCode},success_handler,fail_handler);
	}

	if(dataOk) {
		return(
		<React.Fragment>
			<BlockUI blocked={blockScreen} fullScreen>
				<div className="card">
					<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
						<Grid item xs={12} sm={6} md={4} lg={3} className="field padding-med">
							<label htmlFor="name">Nume unitate*</label>
							<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={2} lg={1} className="field padding-med">
							<label htmlFor="fiscal_code">Cod fiscal*</label>
							<InputText name="fiscal_code" id="fiscal_code" style={{"width":"100%"}} value={inputValues.fiscal_code} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={2} className="field padding-med">
							<label htmlFor="email">Email*</label>
							<InputText name="email" id="email" style={{"width":"100%"}} value={inputValues.email} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={2} lg={2} className="field padding-med">
							<label htmlFor="phone">Phone*</label>
							<InputText name="phone" id="phone" style={{"width":"100%"}} value={inputValues.phone} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={12} lg={4} className="field padding-med">
							<label htmlFor="address">Adresa*</label>
							<InputText name="address" id="address" style={{"width":"100%"}} value={inputValues.address} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3} className="field padding-med">
							<label htmlFor="general_manager">Director general*</label>
							<InputText name="general_manager" id="general_manager" style={{"width":"100%"}} value={inputValues.general_manager} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3} className="field padding-med">
							<label htmlFor="economic_manager">Director economic*</label>
							<InputText name="economic_manager" id="economic_manager" style={{"width":"100%"}} value={inputValues.economic_manager} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3} className="field padding-med">
							<label htmlFor="aquisition_manager">Comp. APCSSA*</label>
							<InputText name="aquisition_manager" id="aquisition_manager" style={{"width":"100%"}} value={inputValues.aquisition_manager} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")}/>
						</Grid>
					{/* ANAF SPV e-Factura */}
					<Grid item xs={12}>
						<Divider align="left">
							<span style={{fontSize:"14px", fontWeight:"bold", color:"#444"}}>
								<i className="pi pi-cloud" style={{marginRight:"6px"}}/>
								Configurare ANAF SPV (e-Factura)
							</span>
						</Divider>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} style={{paddingLeft:"8px", marginBottom:"6px"}}>
						{anafConfig.has_token ?
							<Tag value="Token ANAF activ" severity="success" style={{marginRight:"8px"}}/>
							:
							<Tag value="Neautentificat ANAF" severity="danger" style={{marginRight:"8px"}}/>
						}
						{anafConfig.has_token && anafConfig.token_expires_at &&
							<span style={{fontSize:"12px", color:"#555", marginRight:"16px", fontWeight:"bold"}}>
								Expira: {formatDataRO(anafConfig.token_expires_at)}
							</span>
						}
						<Button label="Autorizeaza cu ANAF" icon="pi pi-external-link"
							className="p-button-sm p-button-info" style={{marginRight:"6px"}}
							onClick={handleGetAuthorizeUrl}/>
						<Button icon="pi pi-refresh" tooltip="Verifica status token"
							tooltipOptions={{position:"top"}}
							className="p-button-sm p-button-secondary p-button-text"
							onClick={loadAnafConfig}/>
					</Grid>
				</Grid>
			</div>
			{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
		</BlockUI>

		{/* Dialog autorizare ANAF - introducere cod */}
		<Dialog header="Autorizare ANAF - Introduceti codul" visible={openAnafDialog}
			style={{width:"520px"}} modal
			onHide={() => setOpenAnafDialog(false)}>
			<div style={{padding:"8px"}}>
				<p style={{marginBottom:"8px", fontSize:"13px"}}>
					1. Apasati butonul de mai jos pentru a deschide pagina ANAF in browser nou.<br/>
					2. Autentificati-va cu certificatul digital.<br/>
					3. Dupa autentificare, ANAF redirectioneaza catre o adresa cu parametrul <b>code=...</b><br/>
					4. Copiati valoarea codului si introduceti-o mai jos.
				</p>
				{authorizeUrl &&
					<Button label="Deschide pagina ANAF" icon="pi pi-external-link"
						className="p-button-sm p-button-secondary" style={{marginBottom:"12px"}}
						onClick={() => window.open(authorizeUrl, "_blank")}/>
				}
				<br/>
				<label>Cod autorizare (din URL-ul de redirect)</label><br/>
				<InputText value={anafCode}
					onChange={(e) => setAnafCode(e.target.value)}
					style={{width:"100%", marginTop:"6px"}} className="p-inputtext-sm"
					placeholder="Copiati codul din URL: ?code=XXXXXXXX"/>
				<div style={{marginTop:"12px", display:"flex", gap:"8px", justifyContent:"flex-end"}}>
					<Button label="Anuleaza" icon="pi pi-times"
						className="p-button-sm p-button-secondary"
						onClick={() => setOpenAnafDialog(false)}/>
					<Button label="Confirma si obtine token" icon="pi pi-check"
						className="p-button-sm p-button-success p-button-raised"
						onClick={handleExchangeCode}/>
				</div>
			</div>
		</Dialog>
	</React.Fragment>
	);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);
	}
};

export default UnitData;

